import { render } from "./InterfaceTabHeader.vue?vue&type=template&id=08a5d978&scoped=true"
import script from "./InterfaceTabHeader.vue?vue&type=script&lang=js"
export * from "./InterfaceTabHeader.vue?vue&type=script&lang=js"

import "./InterfaceTabHeader.vue?vue&type=style&index=0&id=08a5d978&scoped=true&lang=scss"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a5d978"]])

export default __exports__